/* global UC_UI */

const MAPBOX_SERVICE_ID = 'U8QkTd2W'

export function mapboxServiceAccepted() {
  try {
    var c, i
    c = JSON.parse(localStorage.uc_settings)
    for (i = 0; i < c.services.length; i++) {
      if (c.services[i].id === MAPBOX_SERVICE_ID) {
        return c.services[i].status
      }
    }
  } catch (e) {
    return false
  }
}

export function showMapboxServiceInfo() {
  UC_UI.showSecondLayer(MAPBOX_SERVICE_ID)
}

export function acceptMapboxService(callback) {
  UC_UI.acceptService(MAPBOX_SERVICE_ID).then(callback)
}
